import { render, staticRenderFns } from "./VerifyAccountModal.vue?vue&type=template&id=2c726573&scoped=true"
import script from "./VerifyAccountModal.vue?vue&type=script&lang=js"
export * from "./VerifyAccountModal.vue?vue&type=script&lang=js"
import style0 from "./VerifyAccountModal.vue?vue&type=style&index=0&id=2c726573&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c726573",
  null
  
)

export default component.exports